<template>
  <el-button
    type="primary"
    v-if="loading"
    icon="el-icon-loading"
    disabled
  ></el-button>
  <el-button type="primary" @click="onSubmit" v-else>确认</el-button>
</template>

<script>
import bus from "../../utils/bus";
export default {
  name: "submitBtn",
  mounted() {
    // console.log('这里吗？');
    // 接收http.js文件传来的通知
    bus.$on("btnStatus", (msg) => {
      this.loading = msg;
    });
    bus.$on("isOnsubmit", (msg) => {
      this.isOnsubmit = msg;

    });




  },
  beforeDestroy() {
    bus.$off("btnStatus");
    bus.$off("isOnsubmit");
  },
  data() {
    return {
      loading: false,
      isOnsubmit: true,
    };
  },
  props: {
    data: {},
    rules: {},
    url: "",
    JSON_Boolean: Boolean,
    special: "",
    contentType:''
  },
  methods: {
    // 提交
    onSubmit() {
      this.loading = true;

      if (this.JSON_Boolean) {
        this.$emit("toJSON");
      }

      // console.log(this.rules);


      if (this.isOnsubmit == true) {
        // 如果toJSON 方法通过了，走提交接口
        this.$nextTick(function () {
          // console.log(this.rules);
          // console.log(this.data,'this.data----');
          // console.log(this.contentType,'this.contentType------');
          this.$post(this.url, this.data, this.rules,undefined,this,this.contentType).then((res) => {
            // console.log(this.special);



            if (this.special == "walletkey") {
              this.$message.success(
                "应生成" +
                  res.data.total_count +
                  "条,已生成" +
                  res.data.insert_count +
                  "条"
              );
            } else {
              this.$message.success(res.msg);
            }
            // 触发父组件自定义事件刷新表格
            this.$emit("onSubmitDig");
            this.loading = false;
            console.log(this.loading,'this.loading========');
          });
        });
      }

    },
  },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/common/mine/submitBtn.vue